import { render, staticRenderFns } from "./LoadingModel.vue?vue&type=template&id=580767ce"
import script from "./LoadingModel.vue?vue&type=script&lang=js"
export * from "./LoadingModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports